import gql from 'graphql-tag';

const getCardTemplatesQuery = gql`
  query getCardTemplates($offset: Int = 0, $limit: Int = 20) {
    cardTemplates(slice: { offset: $offset, limit: $limit }) {
      total
      records {
        id
        side
        name
        card_elements {
          id
          type
          frame {
            x
            y
            width
            height
            rotation
          }
          z_index
        }
      }
    }
  }
`;

export default getCardTemplatesQuery;
